// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CreditCard20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CreditCard20Circle: FC<CreditCard20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="25"
        >
            <path d="M18.094 8.027v1.375H5.906V8.027h12.188ZM5.906 16.277v-4.125h12.188v4.125H5.906Z" />
            <path
                d="M12 24.152c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12s-12 5.372-12 12c0 6.627 5.373 12 12 12Zm7.087-6.91c.275-.274.413-.596.413-.965v-8.25c0-.37-.138-.69-.413-.965a1.358 1.358 0 0 0-.993-.41H5.906c-.377 0-.706.137-.986.41-.28.274-.42.596-.42.965v8.25c0 .37.14.69.42.964.28.274.609.41.986.41h12.188c.386 0 .717-.136.993-.41Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default CreditCard20Circle;
